import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';
import { About, Services, Maintenance, Login, Signup, Works } from '../pages';
import HomeLayout from '../components/Layout/HomeLayout';

function PublicRoutes() {
  const location = useLocation();

  useEffect(() => {
   
    document.title = `Deeze  ${location.pathname.replace('/', '| ').toUpperCase()}`;
  }, [location]);

  return (
    <Routes>
      <Route path='/' element={<HomeLayout />} />
      <Route exact path='/home' element={<HomeLayout />} />
      <Route path='/about' element={<About />} />
      <Route path='/service' element={<Services />} />
      <Route path='/login' element={<Login />} />
      <Route path='/signup' element={<Signup />} />
      <Route path='/works' element={<Works />} />
      <Route path='*' element={<Maintenance />} />
    </Routes>
  );
}

export default PublicRoutes;
